import { render, staticRenderFns } from "./AssignModal.vue?vue&type=template&id=58faa9d0&scoped=true&"
import script from "./AssignModal.vue?vue&type=script&lang=js&"
export * from "./AssignModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./AssignModal.vue?vue&type=style&index=1&id=58faa9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58faa9d0",
  null
  
)

export default component.exports